import { render, staticRenderFns } from "./LinkToolbar.vue?vue&type=template&id=4bc6a57b&"
import script from "./LinkToolbar.vue?vue&type=script&lang=js&"
export * from "./LinkToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports